import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Cursos', path: '/cursos' },
    { name: 'Sobre', path: '/sobre' },
    { name: 'Redes Sociais', path: '/redes' },
    { name: 'Suporte', path: '/suporte' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-black/95 backdrop-blur-lg shadow-[0_0_30px_rgba(220,20,60,0.3)]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/sobre" className="flex items-center gap-3 group cursor-pointer">
            <img
              src="https://static.readdy.ai/image/f3c00b2c29fcf7feb72ef3eed1992611/5a4cbd72ff56ca19d5c602b626696b36.png"
              alt="Tech Tide Logo"
              className="h-12 w-12 object-contain group-hover:scale-110 transition-transform duration-300"
            />
            <span className="text-2xl font-black text-white group-hover:text-red-600 transition-colors">
              TECH TIDE
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-red-600 drop-shadow-[0_0_10px_rgba(220,20,60,0.8)]'
                    : 'text-gray-300 hover:text-red-600'
                }`}
              >
                {link.name}
              </Link>
            ))}

            <Link
              to="/cursos"
              className="px-6 py-2.5 bg-red-600 text-white font-bold uppercase text-sm rounded-lg hover:bg-red-700 hover:shadow-[0_0_20px_rgba(220,20,60,0.6)] hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
            >
              Entrar pro Jogo
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white text-3xl w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-lg border-t border-red-900">
          <div className="px-6 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-lg font-medium transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-red-600'
                    : 'text-gray-300 hover:text-red-600'
                }`}
              >
                {link.name}
              </Link>
            ))}

            <Link
              to="/cursos"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block w-full py-3 bg-red-600 text-white text-center font-bold uppercase rounded-lg hover:bg-red-700 transition-colors cursor-pointer"
            >
              Entrar pro Jogo
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
